export default __webpack_public_path__ + "static/media/rabbit_type_3_1.cd96b4b6.svg";